module.exports = __webpack_public_path__ + "files/155acf548c71af92fcf9597e09f6061e.png";


//////////////////
// WEBPACK FOOTER
// ./images/emoji-sheets/skintone-11.png
// module id = 1500
// module chunks = 60